export default "<strong>TARGET Location information:</strong>\n\n<strong>Weather / Condition</strong><br>\n300/25 VIS/Cloud NR";